import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="ema-footer">
      {/* Newsletter / CTA Banner */}
      <div className="ema-footer-cta">
        <div className="ema-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px' }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: '#fff' }}>
              Restez informé
            </h3>
            <p style={{ margin: '4px 0 0', fontSize: '14px', color: 'rgba(255,255,255,0.8)' }}>
              Suivez les actualités de l'École de la Magistrature sur nos réseaux sociaux.
            </p>
          </div>
          <div className="ema-footer-socials">
            <a href="https://www.facebook.com/profile.php?id=100064246498614" target="_blank" rel="noreferrer" className="ema-social-btn" aria-label="Facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="https://www.youtube.com/@EcoledelaMagistrature" target="_blank" rel="noreferrer" className="ema-social-btn" aria-label="YouTube">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
            <a href="mailto:info@ema.edu.ht" className="ema-social-btn" aria-label="Email">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer Grid */}
      <div className="ema-container ema-footer-grid">
        <div className="ema-footer-brand">
          <img src={logo} alt="EMA" className="ema-footer-logo" />
          <p className="ema-footer-title">École de la Magistrature</p>
          <p className="ema-footer-text">
            Institution de formation judiciaire : formation initiale et continue
            des magistrats, greffiers et professionnels de la Justice.
          </p>
          <p className="ema-footer-muted">
            Port-au-Prince, Haïti • Horaires : Lun–Ven (8h–16h)
          </p>
          <p className="ema-footer-muted" style={{ marginTop: 6 }}>
            Tél : (+509) 2813-1818
          </p>
        </div>

        <div className="ema-footer-col">
          <p className="ema-footer-coltitle">L'École</p>
          <Link to="/ecole" className="ema-footer-link">Présentation</Link>
          <Link to="/formations" className="ema-footer-link">Formations</Link>
          <Link to="/proces-fictifs" className="ema-footer-link">Procès fictifs</Link>
          <Link to="/mediatheque" className="ema-footer-link">Médiathèque</Link>
          <Link to="/ecole/temoignages" className="ema-footer-link">Témoignages</Link>
        </div>

        <div className="ema-footer-col">
          <p className="ema-footer-coltitle">Candidats</p>
          <Link to="/concours" className="ema-footer-link">Concours & Admissions</Link>
          <Link to="/register" className="ema-footer-link">Créer un compte</Link>
          <Link to="/login" className="ema-footer-link">Espace candidat</Link>
          <Link to="/announcements" className="ema-footer-link">Actualités</Link>
          <Link to="/ressources" className="ema-footer-link">Documents & ressources</Link>
        </div>

        <div className="ema-footer-col">
          <p className="ema-footer-coltitle">Informations</p>
          <Link to="/contact" className="ema-footer-link">Contact</Link>
          <a className="ema-footer-link" href="https://moodle.ema.edu.ht" target="_blank" rel="noreferrer">
            Campus numérique (Moodle)
          </a>
          <Link to="/mentions-legales" className="ema-footer-link">Mentions légales</Link>
          <Link to="/politique-confidentialite" className="ema-footer-link">Confidentialité</Link>
          <Link to="/accessibilite" className="ema-footer-link">Accessibilité</Link>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ema-footer-bottom">
        <div className="ema-container ema-footer-bottom-inner">
          <span>© {year} École de la Magistrature — Tous droits réservés.</span>
          <span className="ema-footer-bottom-right">
            Plateforme conçue avec excellence pour la justice haïtienne
          </span>
        </div>
      </div>
    </footer>
  );
}

